import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { AlertTriangle, PenLine } from "lucide-react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import AgreementSignModal from "@/components/AgreementSignModal";

export default function ActionBanner() {
  const { user } = useAuth();
  const [signing, setSigning] = useState(null);
  const { data, refetch } = useQuery({
    queryKey: ["action-items"], enabled: !!user,
    queryFn: () => api.get("/me/action-items").then((r) => r.data),
  });

  const unsigned = data?.unsigned_agreements || [];
  if (!unsigned.length && !data?.profile_incomplete) return null;

  const openSign = async (a) => {
    const { data: ag } = await api.get(`/agreements/${a.id}`);
    setSigning(ag);
  };

  return (
    <div className="rounded-2xl border border-[#D98E73]/40 bg-[#D98E73]/[0.08] p-5 mb-8" data-testid="action-banner">
      <div className="flex items-start gap-3">
        <AlertTriangle size={20} className="text-[#B5794E] shrink-0 mt-0.5" />
        <div className="flex-1">
          <h3 className="text-[#1A242B] font-semibold">A few things need your attention</h3>
          <div className="mt-3 flex flex-wrap gap-2">
            {unsigned.map((a) => (
              <button key={a.id} onClick={() => openSign(a)} data-testid={`action-sign-${a.id}`}
                className="inline-flex items-center gap-1.5 text-sm bg-white border border-[#E5E0D8] rounded-full px-3 py-1.5 hover:border-[#144F75] transition-colors text-[#1A242B]">
                <PenLine size={13} className="text-[#144F75]" /> Sign {a.title}
              </button>
            ))}
            {data?.profile_incomplete && (
              <span className="inline-flex items-center gap-1.5 text-sm bg-white border border-[#E5E0D8] rounded-full px-3 py-1.5 text-[#4A5D6B]">
                Complete your profile
              </span>
            )}
          </div>
        </div>
      </div>
      {signing && <AgreementSignModal agreement={signing} onClose={() => setSigning(null)} onSigned={refetch} />}
    </div>
  );
}
